import { createSlice } from '@reduxjs/toolkit';
import {
  FETCH_PROMO,
  CREATE_PROMO
} from '../constants/constants';

const initialState = {
  list: []
};

const promoSlice = createSlice({
  name: 'promo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(FETCH_PROMO, (state, action) => {
        state.list = action.data.promos;
      })
      .addCase(CREATE_PROMO, (state, action) => {
        state.list.unshift(action.data);
      });
  }
});

export default promoSlice.reducer;
